import React,{useEffect,useState} from "react";
import API from "../services/api";
import "./Attendance.css";

export default function Attendance(){

const [employees,setEmployees]=useState([]);
const [selectedYear,setSelectedYear]=useState("2025");

useEffect(()=>{

fetchAttendance(selectedYear);

},[selectedYear]);

/* ================= FETCH DATA ================= */

const fetchAttendance=async(year)=>{

try{

const res=
await API.get(
`/invoice/attendance?year=${year}`
);

const attendanceData=
res.data;

const grouped={};

attendanceData.forEach((item)=>{

if(
!grouped[
item.employeeName
]
){

grouped[
item.employeeName
]={
employeeName:
item.employeeName,
selectedMonth:"",
rate:item.rate || 50,
months:{}
};

}

grouped[
item.employeeName
]
.months[item.month]={
hours:item.hours,
total:item.total
};

});

setEmployees(
Object.values(grouped)
);

}catch(err){

console.log(err);

}

};

/* ================= MONTH CHANGE ================= */

const handleMonthChange=(
index,
month
)=>{

const updated=
[...employees];

updated[index]
.selectedMonth=
month;

setEmployees(updated);

};

/* ================= RATE CHANGE ================= */

const handleRateChange = (index, value) => {

  const updated = employees.map((emp, i) => {
    if (i === index) {
      return {
        ...emp,
        rate: value
      };
    }
    return emp;
  });

  setEmployees(updated);
};

/* ================= VALID MONTHS ================= */

const validMonths=[

"Jan",
"Feb",
"March",
"April",
"May",
"June",
"July",
"Aug",
"Sep",
"Oct",
"Nov",
"Dec"

];

/* ================= YEAR LIST ================= */

const years=[];

for(
let y=2025;
y<=2026;
y++
){

years.push(y);

}

return(

<div className="container">

<h1>Attendance</h1>

<div className="year-filter">

<label>
Select Year :
</label>

<select
value={selectedYear}
onChange={(e)=>
setSelectedYear(
e.target.value
)
}
>

{years.map((year)=>(

<option
key={year}
value={year}
>

{year}

</option>

))}

</select>

</div>

<div className="table-container">

<table className="attendance-table" border="1" cellPadding="10">

<thead>

<tr>

<th>
Employee Name
</th>

<th>
Month
</th>

<th>
Hours
</th>

<th>
Rate
</th>

<th>
Total Amount
</th>

</tr>

</thead>

<tbody>

{employees.length>0 ? (

employees.map(
(emp,index)=>{

const selectedData=

emp.selectedMonth

? emp.months[
emp.selectedMonth
]

: null;

const total=

selectedData

? selectedData.hours * Number(emp.rate || 0)

: 0;

return(

<tr key={index}>

<td>

{emp.employeeName}

</td>

<td>

<select

className="month-select"

value={
emp.selectedMonth
}

onChange={(e)=>
handleMonthChange(
index,
e.target.value
)
}

>

<option value="">
Month
</option>

{Object.keys(
emp.months
)

.filter((month)=>

validMonths.includes(
month
)

)

.map((month)=>(

<option
key={month}
value={month}
>

{month}

</option>

))}

</select>

</td>

<td className="hours-value">

{selectedData
? selectedData.hours
: "-"
}

</td>

<td>

<input

className="rate-input"

type="text"

value={emp.rate ?? ""}

onChange={(e) =>
  handleRateChange(index, e.target.value === "" ? "" : Number(e.target.value))
}

/>

</td>

<td className="total-amount">

₹ {total}

</td>

</tr>

);

}

)

) : (

<tr>

<td
colSpan="5"
className="no-data"
>

No Attendance Records Found

</td>

</tr>

)}

</tbody>

</table>

</div>

</div>

);

}